import styled from '@emotion/styled';
import { theme } from '@ublend-npm/aulaui-next';

export const ColourIcon = styled.span<{ colour: string }>`
  border-radius: 50%;
  height: ${theme.spacing.medium};
  width: ${theme.spacing.medium};
  background-color: ${(props) => props.colour};
  display: inline-block;
`;
